import {
  SET_STOCKS,
  SET_STOCKS_DATA_LOADING,
  GET_SEARCH_PRODUCTS,
  SET_SEARCH_PRODUCTS_DATA_LOADING,
  GET_SEARCH_SUPPLIERS,
  SET_SEARCH_SUPPLIERS_DATA_LOADING,
  SET_SEARCH_STOCK_BY_ID,
  GET_SEARCH_CATEGORIES,
  SET_SEARCH_CATEGORIES_DATA_LOADING,
} from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const createStock = (requestBody) => async (dispatch) => {
  try {
    dispatch({ type: SET_STOCKS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    const queryParams = {
      companyId,
      branchId,
    };

    const res = await Axios.post(`/api/dashboard/stocks`, requestBody, {
      params: queryParams,
    });
    dispatch({ type: SET_STOCKS_DATA_LOADING, payload: false });
    return res?.data?.success !== false;
  } catch (err) {
    dispatch({ type: SET_STOCKS_DATA_LOADING, payload: false });
    const message = err?.response?.data?.error;
    return typeof message === 'string' && message.trim() ? message : false;
  }
};

/**
 * Fetch stocks with search, filters, and pagination via dashboard search-stocks API.
 * Params: { keyword, page, rowsPerPage, filters: { productId, supplierId } }.
 */
export const getStocks = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: SET_STOCKS_DATA_LOADING, payload: true });
    const auth = store.getState().authState;
    let companyId = auth.companyId;
    let branchId = auth.branchId;
    const branchList = auth.branchList || [];

    if (!branchId && branchList.length > 0) {
      branchId = branchList[0].id;
      if (branchList[0].companyId != null) companyId = branchList[0].companyId;
    }
    if (!companyId || !branchId) {
      dispatch({ type: SET_STOCKS, payload: { data: [], totalRowCount: 0, page: 0, rowsPerPage: 10 } });
      return;
    }

    const keyword = params.keyword != null ? String(params.keyword) : '';
    const page = Number(params.page) || 0;
    const rowsPerPage = Number(params.rowsPerPage) || 10;
    const filters = params.filters || {};
    const queryParams = {
      companyId,
      branchId,
      keyword,
      page,
      rowsPerPage,
      productId: filters.productId ?? '',
      supplierId: filters.supplierId ?? '',
    };

    const res = await Axios.get(`/api/dashboard/stocks/search-stocks`, {
      params: queryParams,
    });

    const body = res.data;
    const apiData = body?.data;
    if (apiData?.error) {
      dispatch({
        type: SET_STOCKS,
        payload: { data: [], totalRowCount: 0, page, rowsPerPage },
      });
      return;
    }

    const rows = Array.isArray(apiData?.data)
      ? apiData.data
      : Array.isArray(apiData)
        ? apiData
        : Array.isArray(body) ? body : [];
    const totalRowCount = apiData?.totalRowCount ?? apiData?.total_stocks ?? body?.totalRowCount;

    dispatch({
      type: SET_STOCKS,
      payload: {
        data: rows,
        totalRowCount,
        page,
        rowsPerPage,
      },
    });
  } catch (err) {
    dispatch({
      type: SET_STOCKS,
      payload: { data: [], totalRowCount: 0, page: 0, rowsPerPage: 10 },
    });
  } finally {
    dispatch({ type: SET_STOCKS_DATA_LOADING, payload: false });
  }
};

export const searchProducts = (keyword) => async (dispatch) => {
  try {
    dispatch({ type: SET_SEARCH_PRODUCTS_DATA_LOADING });
    const companyId = store.getState().authState.companyId;
    const res = await Axios.get(
      `/api/dashboard/products/search-by-code-name-barcode`,
      {
        params: { companyId, keyword },
      }
    );

    dispatch({
      type: GET_SEARCH_PRODUCTS,
      payload: res.data.data,
    });
  } catch (err) { }
};

/**
 * Search products for Add New Stock (stock-type, leaf only). Uses GET search-for-add-stock.
 */
export const searchProductsForAddStock = (keyword) => async (dispatch) => {
  try {
    dispatch({ type: SET_SEARCH_PRODUCTS_DATA_LOADING });
    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    const res = await Axios.get(
      `/api/dashboard/products/search-for-add-stock`,
      { params: { companyId, branchId, keyword: keyword || '' } }
    );
    dispatch({ type: GET_SEARCH_PRODUCTS, payload: res.data?.data ?? res.data ?? [] });
  } catch (err) {
    dispatch({ type: GET_SEARCH_PRODUCTS, payload: [] });
  }
};

/**
 * Get product by id for Add New Stock pre-select (e.g. from ?productId=).
 */
export const getProductByIdForAddStock = (id) => async () => {
  try {
    const res = await Axios.get(`/api/dashboard/products/find-by-id`, {
      params: { id },
    });
    const data = res.data?.data ?? res.data;
    return Array.isArray(data) ? data[0] : data;
  } catch (err) {
    return null;
  }
};

export const searchSuppliers = (params) => async (dispatch) => {
  try {
    dispatch({ type: SET_SEARCH_SUPPLIERS_DATA_LOADING });
    const companyId = store.getState().authState.companyId;

    const queryParams = {
      ...params,
      companyId,
    };

    const res = await Axios.get(`/api/dashboard/suppliers/find-all`, {
      params: queryParams,
    });

    dispatch({
      type: GET_SEARCH_SUPPLIERS,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: GET_SEARCH_SUPPLIERS,
      payload: [],
    });
  }
};

export const searchCategories = (keyword) => async (dispatch) => {
  try {
    dispatch({ type: SET_SEARCH_CATEGORIES_DATA_LOADING });
    const companyId = store.getState().authState.companyId;
    const res = await Axios.get(`/api/dashboard/categories/search-by-name`, {
      params: { companyId, keyword },
    });
    dispatch({
      type: GET_SEARCH_CATEGORIES,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: GET_SEARCH_CATEGORIES,
      payload: [],
    });
  }
};

export const searchStockById = (id, setSelectedProduct) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SEARCH_STOCK_BY_ID,
      payload: []
    });

    const res = await Axios.get(`/api/dashboard/stocks/find-by-id`, {
      params: { id },
    });

    const stockData = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
    if (!stockData) {
      dispatch({ type: SET_SEARCH_STOCK_BY_ID, payload: [] });
      return;
    }

    const selectedProductId = stockData.product_id ?? stockData.productid;

    const selectedProduct = await Axios.get(`/api/dashboard/products/find-by-id`, {
      params: { id: selectedProductId },
    });

    const productData = Array.isArray(selectedProduct?.data?.data) ? selectedProduct.data.data[0] : selectedProduct?.data?.data;
    if (setSelectedProduct && productData) {
      setSelectedProduct({
        id: productData.id,
        name: productData.name,
      });
    }

    dispatch({
      type: SET_SEARCH_STOCK_BY_ID,
      payload: stockData,
    });
  } catch (err) {
    dispatch({
      type: SET_SEARCH_STOCK_BY_ID,
      payload: []
    });
  }
};

export const resetSearchedStock = () => (dispatch) => {
  dispatch({
    type: SET_SEARCH_STOCK_BY_ID,
    payload: []
  });
}

export const updateStock = (id, requestBody) => async (dispatch) => {
  try {
    dispatch({ type: SET_STOCKS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    const queryParams = {
      companyId,
      branchId,
    };

    await Axios.put(`/api/dashboard/stocks/${id}`, requestBody, {
      params: queryParams,
    });

    dispatch({ type: SET_STOCKS_DATA_LOADING, payload: false });
    return true;
  } catch (err) {
    dispatch({ type: SET_STOCKS_DATA_LOADING, payload: false });
    return false;
  }
};

export const exportStocks = (params = {}, format) => async (dispatch) => {
  try {
    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const getTimestampString = () => {
      const pad = (num) => String(num).padStart(2, '0');
      const d = new Date();
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
    };
    const timestamp = getTimestampString();
    const isPdf = format === 'pdf';

    // Transform filter params to match backend query format
    const transformedParams = {
      ...(params?.product?.id
        ? { productId: params.product.id }
        : {}),
      ...(params?.supplier?.id
        ? { supplierId: params.supplier.id }
        : {}),
      ...(params?.category?.id
        ? { categoryId: params.category.id }
        : {}),
    };

    const requestBody = {
      columns: [
        {
          key: 'productCode',
          header: 'Product Code',
        },
        {
          key: 'productName',
          header: 'Product Name',
        },
        {
          key: 'barcode',
          header: 'Barcode',
        },
        {
          key: 'categoryName',
          header: 'Category Name',
        },
        {
          key: 'supplierName',
          header: 'Supplier Name',
        },
        {
          key: 'initial_qty',
          header: 'Initial Quantity',
        },
        {
          key: 'qty',
          header: 'Quantity Remaining',
        },
        {
          key: 'serialNumbers',
          header: 'Serial IDs',
        },
        {
          key: 'unit',
          header: 'Unit',
        },
        {
          key: 'unit_cost',
          header: 'Unit Cost'
        },
        {
          key: 'remaining_cost_of_goods',
          header: 'Remaining Cost of Goods'
        },        
        {
          key: 'selling_price',
          header: 'Unit Price',
        },
        {
          key: 'discount',
          header: 'Discount',
        },
        {
          key: 'wholesale_discount',
          header: 'Wholesale Discount',
        },
        {
          key: 'created_at',
          header: 'Created Date',
        },
        {
          key: 'expire_at',
          header: 'Expire Date',
        },
      ],
      filename: isPdf ? `stocks_export_${timestamp}.pdf` : `stocks_export_${timestamp}.xlsx`,
      sheetName: 'Stocks',
      format: isPdf ? 'pdf' : 'excel',
      ...transformedParams,
      companyId,
      branchId
    };

    const acceptHeader = isPdf
      ? 'application/pdf'
      : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    const response = await Axios.post(
      '/api/dashboard/stocks/export-stocks-file',
      requestBody,
      {
        responseType: 'arraybuffer',
        headers: { Accept: acceptHeader },
      }
    );

    const contentType = response?.headers?.['content-type'] || '';
    const isJson = contentType.toLowerCase().includes('application/json');
    if (isJson && response.data) {
      const text = new TextDecoder().decode(response.data);
      const errBody = (() => { try { return JSON.parse(text); } catch (_) { return {}; } })();
      throw new Error(errBody.message || errBody.error || text || 'Export failed');
    }

    const contentDisposition = response?.headers?.['content-disposition'];
    let downloadFileName =
      requestBody.filename || (isPdf ? 'stocks_export.pdf' : 'stocks_export.xlsx');
    if (contentDisposition && contentDisposition.includes('filename=')) {
      const match = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i
      );
      downloadFileName = decodeURIComponent(
        match?.[1] || match?.[2] || downloadFileName
      );
    }

    const blobType = isPdf ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const blob = new Blob([response.data], { type: blobType });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', downloadFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Export failed', error);
  }
};